import { TThunkAction } from '../../types/redux';
import { ILocation } from '../../types/location';
import { rememberLocation } from './actions';

export function setRegion(region: ILocation): TThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    const {
      tab,
      geo: { locationsMap },
    } = getState();

    dispatch(
      rememberLocation({
        ...locationsMap,
        [tab]: region,
      }),
    );
  };
}
